module.exports = __webpack_public_path__ + "assets/img/28_424_big.c70fb5cb.jpg";